// @ts-nocheck
/* eslint-disable react/jsx-key */
import { Result } from "antd";
import React, { useEffect, useImperativeHandle, useState } from "react";
import { Button, Modal } from "reactstrap";
import OrderCodeCopy from "../OrderCodeCopy";

const COUNTDOWN_SECOND = 1;
const NotificationModal = React.forwardRef((props, ref) => {
  const { isHaveLinkOrderDetail } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [notiState, setNotiState] = useState(undefined);
  const [countdown, setCountdown] = useState(COUNTDOWN_SECOND); // Countdown starts

  useImperativeHandle(ref, () => ({
    open: state => {
      setNotiState(state);
      setIsOpen(true);
      setCountdown(COUNTDOWN_SECOND); // Reset countdown when modal opens
    },
  }));

  useEffect(() => {
    if (isHaveLinkOrderDetail && isOpen && notiState?.status === "success") {
      // Start countdown when the modal is open
      const timer = setInterval(() => {
        setCountdown(prev => {
          if (prev === 1) {
            clearInterval(timer);
            window.open(
              `/manage-orders/${notiState?.successData?.id}`,
              "_blank",
              "noopener,noreferrer"
            );
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer); // Cleanup timer when unmounting
    }
  }, [isOpen, notiState]);

  return (
    <Modal
      size="lg"
      role="dialog"
      autoFocus={true}
      centered={true}
      isOpen={isOpen}
    >
      <Result
        status={notiState?.status}
        title={notiState?.status === "success" ? "Thành công" : "Thất bại"}
        subTitle={
          <div className="d-flex gap-1 align-items-center justify-content-center fw-bold font-size-17">
            <span>Gom vào đơn lấy hàng nhà xe thành công.</span>
            {notiState?.status === "success" && (
              <>
                <span>Mã đơn </span>
                <OrderCodeCopy code={notiState?.successData?.code} />
              </>
            )}
          </div>
        }
        extra={[
          isHaveLinkOrderDetail &&
            notiState?.status === "success" &&
            countdown > 0 && (
              <div
                style={{ fontStyle: "italic" }}
                className="text-center text-muted fw-bold font-size-15 mb-4"
              >
                Tự động chuyển sang chi tiết đơn sau (<b>{countdown}</b>)
                giây...
              </div>
            ),
          <Button
            color="dark"
            onClick={() => {
              setIsOpen(false);
            }}
          >
            {"Đóng"}
          </Button>,
          isHaveLinkOrderDetail &&
            notiState?.status === "success" &&
            notiState?.successData && (
              <Button
                type="button"
                color="success"
                onClick={() => {
                  window.open(
                    `/manage-orders/${notiState?.successData?.id}`,
                    "_blank",
                    "noopener,noreferrer"
                  );
                }}
              >
                {"Xem chi tiết ngay"}
              </Button>
            ),
        ]}
      />
    </Modal>
  );
});

export default NotificationModal;
